import { ComponentRef, forwardRef, ReactNode } from 'react'
import AvatarEditor from 'react-avatar-editor'

type ImageInputProps = {
  image: File | string
  zoom: number
  onZoomChange: (zoom: number) => void
  width?: number
  height?: number
  border?: number
  borderRadius?: number
  minZoom?: number
  maxZoom?: number
  zoomStep?: number
  showZoom?: boolean
  className?: string
  children?: ReactNode
}

const ImageInput = forwardRef<
  ComponentRef<typeof AvatarEditor>,
  ImageInputProps
>(
  (
    {
      image,
      zoom,
      onZoomChange,
      width = 220,
      height = 220,
      border = 20,
      borderRadius = width / 2,
      minZoom = 1,
      maxZoom = 3,
      zoomStep = 0.1,
      showZoom = true,
      className = '',
      children,
    },
    ref
  ) => {
    return (
      <div className={`image-input ${className}`}>
        <AvatarEditor
          ref={ref}
          image={image}
          width={width}
          height={height}
          border={border}
          borderRadius={borderRadius}
          scale={zoom}
        />
        {showZoom && (
          <div className="image-zoom">
            <input
              type="range"
              className="form-range"
              min={minZoom}
              max={maxZoom}
              step={zoomStep}
              value={zoom}
              onChange={e => onZoomChange(Number(e.target.value))}
            />
          </div>
        )}
        {children && <div className="image-actions">{children}</div>}
      </div>
    )
  }
)

export default ImageInput
